import { render, staticRenderFns } from "./LawOfficerGroupManage.vue?vue&type=template&id=feb1ea18&"
import script from "./LawOfficerGroupManage.vue?vue&type=script&lang=js&"
export * from "./LawOfficerGroupManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports